import styled, { css } from "styled-components";
import ArrowDown from "../../../img/icons/arrow-down.svg";
import Reload from "../../../img/icons/reload.svg?react";

export const ChipRowWrapper = styled.div`
  padding: 0 ${({ theme }) => theme.space[2]};
`;

export const ChipRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.space[1]};
  scroll-behavior: smooth;
  overflow-x: auto;
  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => theme.colors.greyLight2} transparent;

  &::-webkit-scrollbar {
    height: 2px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background-color: ${({ theme }) => theme.colors.greyLight2};
  }
`;

export const ChipWrap = styled.div`
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    inset-inline-end: 10px;
    width: 12px;
    height: 8px;
    background: url(${ArrowDown}) no-repeat center;
    background-size: contain;
    transform: translateY(-50%);
    pointer-events: none;
  }
`;

/** Invisible span: same font as ChipSelect, used only to measure selected option text width. */
export const OffscreenLabelMeasure = styled.span`
  position: absolute;
  visibility: hidden;
  font-family: ${({ theme }) => theme.fonts.base};
  font-size: ${({ theme }) => theme.fontSizes[1]};
  white-space: nowrap;
  pointer-events: none;
`;

/** Shared styles for filter dropdown chips and reset button */
const filterChipBaseStyles = css`
  padding: ${({ theme }) => `${theme.space[1]} ${theme.space[2]}`};
  border: ${({ theme }) => theme.borders[0]};
  border-radius: 50px;
  background-color: ${({ theme }) => theme.colors.secondary};
  font-family: ${({ theme }) => theme.fonts.base};
  font-size: ${({ theme }) => theme.fontSizes[1]};
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
`;

export const ChipSelect = styled.select`
  ${filterChipBaseStyles}
  min-width: 60px;
  padding-inline-end: 28px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  appearance: none;
`;

export const ResetChip = styled.button`
  ${filterChipBaseStyles}
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[1]};

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const ReloadIcon = styled(Reload)`
  fill: ${({ theme }) => theme.colors.primary};
  transform: rotate(180deg);
`;
